// extracted by mini-css-extract-plugin
module.exports = {"centers":"n95tn"};